import makeAnimated from "react-select/animated";
import APIS from "../../constant/EndPoint";
import { classNames } from "../../utils/classNames";
import DateRangePicker from "../Reusable/DateRangePicker";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import ComboboxFilter from "../Reusable/ComboboxFilter";
import MultipleSelectField from "../Reusable/MultiSelectField";
import {
  Control,
  FieldErrors,
  UseFormClearErrors,
  UseFormGetValues,
  UseFormRegister,
  UseFormReset,
  UseFormSetValue,
  UseFormWatch,
} from "react-hook-form";
import { IFilter } from "./ConsignmentList";

interface Props {
  register: UseFormRegister<IFilter>;
  errors: FieldErrors<IFilter>;
  setValue: UseFormSetValue<IFilter>;
  getValues: UseFormGetValues<IFilter>;
  reset: UseFormReset<IFilter>;
  watch: UseFormWatch<IFilter>;
  clearErrors: UseFormClearErrors<IFilter>;
  control: Control;
  isFilterVisible: boolean;
}

const OrderFilter = (props: Props) => {
  const {
    register,
    errors,
    setValue,
    getValues,
    reset,
    watch,
    clearErrors,
    control,
  } = props;

  return (
    props?.isFilterVisible && (
      <div className={tw`relative`}>
        <div className={tw`grid grid-cols-3 md:grid-cols-3 gap-x-4 mx-4`}>
          <div className={tw`mt-3`}>
            <MultipleSelectField
              label={"Status"}
              queryKey={"delivery_status__in"}
              register={register(`delivery_status__in`)}
              name={"delivery_status__in"}
              watch={watch}
              setValue={setValue}
              errors={errors?.delivery_status__in}
              url={`${APIS.STATUS}`}
              getValues={getValues}
              params={{
                is_active: true,
              }}
              control={control}
            />
          </div>
          <ComboboxFilter
            url={APIS.BRANCH}
            queryKey={"branch"}
            register={register("pickup_branch")}
            errors={errors?.pickup_branch}
            name={"pickup_branch"}
            label={"Pickup Branch"}
            setValue={setValue}
            params={{
              is_active: true,
            }}
            placeholder={"Select Pickup Branch"}
            getValues={getValues}
            clearErrors={clearErrors}
            control={control}
          />
          {/* <ComboboxFilter
            url={APIS.LOCATION}
            params={{ level: 3, is_active: true }}
            queryKey={"location"}
            register={register("destination")}
            errors={errors?.destination}
            name={"destination"}
            label={"Select Destination City"}
            setValue={setValue}
            placeholder={"Select Destination City"}
            getValues={getValues}
            clearErrors={clearErrors}
            control={control}
          /> */}
          <div className={tw`mt-3`}>
            <MultipleSelectField
              label={"Select Destination City"}
              queryKey={"destination__in"}
              register={register(`destination__in`)}
              name={"destination__in"}
              watch={watch}
              setValue={setValue}
              errors={errors?.destination__in}
              url={`${APIS.LOCATION}`}
              getValues={getValues}
              params={{ level: 3, is_active: true }}
              control={control}
            />
          </div>

          <ComboboxFilter
            url={APIS.PAYMENT_METHOD_TYPE}
            queryKey={"payment-method-type"}
            register={register("payment_method")}
            errors={errors?.payment_method}
            name={"payment_method"}
            label={"Payment Method"}
            params={{
              is_active: true,
            }}
            setValue={setValue}
            placeholder={"Select Payment Method"}
            getValues={getValues}
            clearErrors={clearErrors}
            control={control}
          />
          <ComboboxFilter
            url={APIS.WAREHOUSE}
            queryKey={"warehouse"}
            register={register("pickup_branch__warehouse")}
            errors={errors?.pickup_branch__warehouse}
            name={"pickup_branch__warehouse"}
            label={"Origin Warehouse"}
            params={{
              is_active: true,
            }}
            setValue={setValue}
            placeholder={"Select Origin Warehouse"}
            getValues={getValues}
            clearErrors={clearErrors}
            control={control}
          />
          <ComboboxFilter
            url={APIS.WAREHOUSE}
            queryKey={"warehouse"}
            register={register("destination_branch__warehouse")}
            errors={errors?.destination_branch__warehouse}
            name={"destination_branch__warehouse"}
            label={"Destination Warehouse"}
            setValue={setValue}
            params={{
              is_active: true,
            }}
            placeholder={"Select Destination Warehouse"}
            getValues={getValues}
            clearErrors={clearErrors}
            control={control}
          />
          <ComboboxFilter
            url={APIS.MERCHANT}
            queryKey={"merchant"}
            register={register("vendor")}
            errors={errors?.vendor}
            name={"vendor"}
            label={"Vendor"}
            params={{
              is_active: true,
            }}
            setValue={setValue}
            placeholder={"Select Vendor"}
            getValues={getValues}
            clearErrors={clearErrors}
            control={control}
          />
          <DateRangePicker
            label={"Select Date Range"}
            setValue={setValue}
            name={"created__range"}
            getValues={getValues}
          />
          <ComboboxFilter
            url={APIS.CUSTOMER}
            queryKey={"customer"}
            register={register("sender")}
            errors={errors?.sender}
            name={"sender"}
            label={"Sender"}
            setValue={setValue}
            params={{
              is_active: true,
            }}
            placeholder={"Select Sender"}
            getValues={getValues}
            clearErrors={clearErrors}
            control={control}
          />
          <ComboboxFilter
            url={APIS.CUSTOMER}
            queryKey={"receiver"}
            register={register("receiver")}
            errors={errors?.receiver}
            name={"receiver"}
            label={"Receiver"}
            params={{
              is_active: true,
            }}
            setValue={setValue}
            placeholder={"Select Receiver"}
            getValues={getValues}
            clearErrors={clearErrors}
            control={control}
          />
          <ComboboxFilter
            url={APIS.RIDER}
            queryKey={"rider"}
            register={register("assign_order")}
            errors={errors?.assign_order}
            name={"assign_order"}
            label={"Rider"}
            params={{
              is_active: true,
            }}
            setValue={setValue}
            placeholder={"Select Rider"}
            getValues={getValues}
            clearErrors={clearErrors}
            control={control}
          />
          <ComboboxFilter
            url={APIS.STAFF}
            queryKey={"staff"}
            register={register("staff")}
            errors={errors?.staff}
            name={"staff"}
            label={"Staff"}
            params={{
              is_active: true,
              is_staff: true,
            }}
            setValue={setValue}
            placeholder={"Select Staff"}
            getValues={getValues}
            clearErrors={clearErrors}
            control={control}
          />
        </div>
        <button className={tw`absolute -top-5 right-5`} onClick={() => reset()}>
          Reset
        </button>
      </div>
    )
  );
};

export default OrderFilter;
